import { formatToKoreanCurrency, transNum } from '../../func/func';
import { formatCurrency, NumberwithComma } from '../../func/Function';

// 매물 전체 리스트 표시 마커 생성
export const createCustomOverlay = (data: any, kakao: any) => {
  const clusterId = `cluster-${data.code}`;
  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.lat, data.lng),
    content: `
   <div id=${clusterId}
      style="width: max-content; border-radius: 8px; border: 1px solid #008AFF; overflow: hidden; box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12), 0px 1px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 1px 0px rgba(0, 0, 0, 0.08); display: ${data.name ? 'block' : 'none'};">
      <div
        style="padding: 5px 10px; background-color: #008AFF; color: white; font-family: 'Spoqa Han Sans Neo'; font-size: 12px; display: flex; flex-direction: row; justify-content: center; align-items: center; white-space:noWrap; text-align:center">
        ${data.name || ''}
      </div>
      <div
      style="width:100%;padding: 2px 10px; background-color: white; color: #171E26; font-family: 'Spoqa Han Sans Neo'; font-size: 14px; display: flex; justify-content: center; align-items: center;">
      ${Number(data.cnt).toLocaleString()}
    </div>
    </div>`,
    zIndex: 1,
  });

  return overlay;
};

// level 6이하 마커
export const underLevel6Marker = (data: any, index: number, kakao: any) => {
  const markerId = `marker-${index}`;
  return new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.lat, data.lng),
    content: `
    <div
    id="${markerId}"
    style="
    font-family:'Spoqa Han Sans Neo';
    border-radius: 8px;
    border-style: solid;
    border-color: #00c46f;
    border-width: 1px;
    display: flex;
    flex-direction: column;
    gap: 0px;
    align-items: center;
    justify-content: flex-start;
    width: 98px;
    position: relative;
    cursor: pointer;
  "
    onclick="window.dispatchEvent(new CustomEvent('markerClick', { detail: ${index} }))"
  >
    <div
      style="
      background: #F45551;
      border-radius: 8px 8px 0px 0px;
      padding: 4px 12px 4px 12px;
      display: flex;
      flex-direction: row;
      gap: 0px;
      align-items: center;
      justify-content: center;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    "
    >
      <div
        style="
        color: #ffffff;
        text-align: left;
        font-size: var(--spoqa-body-12medium-font-size, 12px);
        line-height: var(--spoqa-body-12medium-line-height, 145%);
        letter-spacing: var(--spoqa-body-12medium-letter-spacing, -0.05em);
        font-weight: var(--spoqa-body-12medium-font-weight, 500);
        position: relative;
      "
      >
        ${data.caseno}
      </div>
    </div>
    <div
      style="
      background: #ffffff;
      padding: 4px 12px 4px 12px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      align-items: center;
      justify-content: center;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    "
    >
      <div
        style="
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
      "
      >
        <div
          style="
          color: var(--alias-color-text-text-primary, #171e26);
          text-align: left;
          font-size: var(--spoqa-body-12medium-font-size, 12px);
          line-height: var(--spoqa-body-12medium-line-height, 145%);
          letter-spacing: var(--spoqa-body-12medium-letter-spacing, -0.05em);
          font-weight: var(--spoqa-body-12medium-font-weight, 500);
          position: relative;
        "
        >
          최저 낙찰가
        </div>
        <div
          style="
          color: var(--alias-color-text-text-primary, #171e26);
          text-align: left;
          font-size: var(--spoqa-body-16bold-font-size, 16px);
          line-height: var(--spoqa-body-16bold-line-height, 145%);
          letter-spacing: var(--spoqa-body-16bold-letter-spacing, -0.05em);
          font-weight: var(--spoqa-body-16bold-font-weight, 700);
          position: relative;
        "
        >
          ${(data.minprice / 100000000).toFixed(1)}억원
        </div>
      </div>
    </div>
    <div
      style="
      background: var(--alias-color-text-white-text-primary, #ffffff);
      border-radius: 0px 0px 8px 8px;
      padding: 0px 12px 4px 12px;
      display: flex;
      flex-direction: column;
      gap: 0px;
      align-items: center;
      justify-content: center;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    "
    >
      <div
        style="
        color: var(
          --alias-color-text-dark-text-secondary,
          rgba(23, 30, 38, 0.78)
        );
        text-align: left;
        font-size: var(--spoqa-body-12medium-font-size, 12px);
        line-height: var(--spoqa-body-12medium-line-height, 145%);
        letter-spacing: var(--spoqa-body-12medium-letter-spacing, -0.05em);
        font-weight: var(--spoqa-body-12medium-font-weight, 500);
        position: relative;
      "
      >
        ${data.category}
      </div>
    </div>
    <div
      style="
      position:absolute; 
      top:-19px;
      right:0px;
      background: var(
    --alias-color-text-dark-text-secondary,
    rgba(23, 30, 38, 0.78)
  );
      border-radius: 999px;
      padding: 4px 8px 4px 8px;
      display: flex;
      flex-direction: row;
      gap: 0px;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 12px;
      font-weight: 500;
"
>
유찰 ${data.bidcount}회
</div>

    <div style ="position:absolute; bottom:-13px;">
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10" fill="none">
<path d="M12.0262 3.38086L7.11328 9.11256L2.20039 3.38086H12.0262Z" fill="white" stroke="#03C571"/>
<path d="M7.11523 8.30111L0 0H14.2305L7.11523 8.30111Z" fill="white"/>
</svg>
    </div>
  </div>
  `,
    zIndex: 1,
  });
};

// 경공매 마커
export const makeAuctionMarker = (
  data: any,
  kakao: any,
  selectedPriceOption: string,
  selectedAreaOption: string,
) => {
  let PriceValue;

  if (selectedPriceOption === 'total' && selectedAreaOption === 'pyeong') {
    PriceValue = formatCurrency(data.totalprice_meter);
  } else if (
    selectedPriceOption === 'total' &&
    selectedAreaOption === 'meter'
  ) {
    PriceValue = formatCurrency(data.totalprice_meter);
  } else if (
    selectedPriceOption === 'unit' &&
    selectedAreaOption === 'pyeong'
  ) {
    PriceValue = formatCurrency(data.price_per_pyeong);
  } else if (selectedPriceOption === 'unit' && selectedAreaOption === 'meter') {
    PriceValue = formatCurrency(data.price_per_meter);
  } else {
    PriceValue = '';
  }

  let areaValue;

  if (selectedAreaOption === 'pyeong') {
    areaValue = `${NumberwithComma(data.pyeong)}평`;
  } else if (selectedAreaOption === 'meter') {
    areaValue = `${NumberwithComma(data.area)}㎡`;
  } else {
    areaValue = '';
  }

  let typeText = '';

  if (
    data.category === '연립' ||
    data.category === '아파트' ||
    data.category === '오피스텔' ||
    data.category === '근린상가'
  ) {
    typeText = '전용';
  } else if (
    data.category === '빌딩' ||
    data.category === '다가구(원룸등)' ||
    data.category === '근린시설'
  ) {
    typeText = '연면적';
  } else {
    typeText = data.type;
  }

  return new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.y, data.x),
    content: `
 <div style="position: relative">
    <div
      style="
        background: #ffffff;
        border-radius: 4px;
        padding: 5px 6px 4px 6px;
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: center;s
        flex-shrink: 0;
        border: 2px solid #009CB1;
      "
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          gap: 0px;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        "
      >
        <div
          style="
            color: #000000;
            text-align: center;
            font-family:Spoqa Han Sans Neo;
            font-size: 13px;
            line-height: 145%;
            letter-spacing: -0.05em;
            font-weight:700;
            position: relative;
            align-self: stretch;
          "
        >
          ${PriceValue}
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            gap: 2px;
            align-items: center;
            justify-content: center;
            align-self: stretch;
            flex-shrink: 0;
            position: relative;
          "
        >
          <div
            style="
              color: rgba(55, 56, 60, 0.61);
              text-align: center;
              font-family:Spoqa Han Sans Neo;
              font-size: 10px;
              line-height: 11px;
              letter-spacing: -0.05em;
              font-weight: 400;
            "
          >
          ${typeText}
          </div>
          <div
            style="
              color:rgba(55, 56, 60, 0.61);
              text-align: center;
              font-family:Spoqa Han Sans Neo;
              font-size: 10px;
              line-height: 11px;
              letter-spacing: -0.05em;
              font-weight: 400;
            "
          >
            ${areaValue}
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: center; align-items: flex-start; position:absolute; left:38%; bottom:-8px">
     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" fill="none">
          <path d="M4 1.5H2.91289L3.62037 2.3254L8.86111 8.4396C9.45976 9.13801 10.5402 9.13801 11.1389 8.4396L16.3796 2.3254L17.0871 1.5H16H4Z" fill="white" stroke="#1E9B6B" />
          <rect width="20" height="2" fill="white" />
        </svg>
    </div>
  
  <div
    style="
      color:#ffffff;
      text-align: center;
      font-family:Spoqa Han Sans Neo;
      font-size: 11px;
      line-height: 12px;
      letter-spacing: -0.05em;
      font-weight: 700;
      position: absolute;
      top: -15px;
      left:0;
      background: #009cb1;
      border-radius: 999px;
      padding: 4px 8px 4px 8px;
      display: flex; 
      align-items: center;
      justify-content: center;
    "
  >
    ${data.category}
  </div>

</div>
`,
    zIndex: 1,
  });
};

// 실거래가 마커
export const makeOnTradeMarker = (
  data: any,
  kakao: any,
  selectedPriceOption: string,
  selectedAreaOption: string,
) => {
  let PriceValue;

  if (selectedPriceOption === 'total' && selectedAreaOption === 'pyeong') {
    PriceValue = formatCurrency(data.totalprice_meter);
  } else if (
    selectedPriceOption === 'total' &&
    selectedAreaOption === 'meter'
  ) {
    PriceValue = formatCurrency(data.totalprice_meter);
  } else if (
    selectedPriceOption === 'unit' &&
    selectedAreaOption === 'pyeong'
  ) {
    PriceValue = formatCurrency(data.price_per_pyeong);
  } else if (selectedPriceOption === 'unit' && selectedAreaOption === 'meter') {
    PriceValue = formatCurrency(data.price_per_meter);
  } else {
    PriceValue = '';
  }

  let areaValue;

  if (selectedAreaOption === 'pyeong') {
    areaValue = `${NumberwithComma(data.pyeong)}평`;
  } else if (selectedAreaOption === 'meter') {
    areaValue = `${NumberwithComma(data.area)}㎡`;
  } else {
    areaValue = '';
  }

  let typeText = '';

  if (
    data.type === '연립주택' ||
    data.type === '단독주택' ||
    data.type === '아파트' ||
    data.type === '오피스텔' ||
    data.type === '상가'
  ) {
    typeText = '전용';
  } else if (data.type === '빌딩') {
    typeText = '연면적';
  } else {
    typeText = data.category;
  }

  return new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.y, data.x),
    content: `
 <div style="position: relative">
  <div
    style="
      background: #ffffff;
      border-radius: 4px;
      border: 2px solid #5c5c5c;
      padding: 5px 6px 4px 6px;
      display: flex;
      flex-direction: row;
      gap: 6px;
      align-items: center;
      justify-content: center;
    "
  >
    <div
      style="
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: center;
        justify-content: center;
      "
    >
      <div
        style="
          color: #000000;
          text-align: center;
          font-family:Spoqa Han Sans Neo;
          font-size: 13px;
          line-height: 145%;
          letter-spacing: -0.05em;
          font-weight:700;
        "
      >
        ${PriceValue}
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          gap: 2px;
          align-items: flex-start;
          justify-content: flex-start;
          flex-shrink: 0;
        "
      >
        <div
          style="
            display: flex;
            flex-direction: row;
            gap: 2px;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            style="
              color:rgba(55, 56, 60, 0.61);
              text-align: center;
              font-family:Spoqa Han Sans Neo;
              font-size: 10px;
              line-height: 11px;
              letter-spacing: -0.05em;
              font-weight: 400;
            "
          >
            ${typeText}
          </div>
          <div
            style="
              color:rgba(55, 56, 60, 0.61);
              text-align: center;
              font-family:Spoqa Han Sans Neo;
              font-size: 10px;
              line-height: 11px;
              letter-spacing: -0.05em;
              font-weight: 400;
            "
          >
          ${areaValue}
          </div>
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            gap: 4px;
            align-items: center;
            justify-content: center;
            align-self: stretch;
          "
        >
          <div
            style="
              color:rgba(55, 56, 60, 0.61);
              text-align: center;
              font-family:Spoqa Han Sans Neo;
              font-size: 10px;
              line-height: 11px;
              letter-spacing: -0.05em;
              font-weight: 400;
            "
          >
           ${data.dealdate}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="display: flex; justify-content: center; align-items: flex-start; position:absolute; left:38%; bottom:-8px">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" fill="none">
      <mask id="mask0_4260_4788" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="10">
        <rect width="20" height="10" fill="black"/>
      </mask>
      <g mask="url(#mask0_4260_4788)">
        <path d="M4 -1H2L3.2 0.6L8.4 7.53333C9.2 8.6 10.8 8.6 11.6 7.53333L16.8 0.6L18 -1H16H4Z" fill="white" stroke="#5C5C5C" stroke-width="2"/>
      </g>
    </svg>
    </div>
  <div
    style="
      color: #ffffff;
      text-align: center;
      font-family:Spoqa Han Sans Neo;
      font-size: 11px;
      line-height: 12px;
      letter-spacing: -0.05em;
      font-weight: 700;
      position: absolute;
      top: -15px;
      left:0;
      padding: 4px 8px 4px 8px;
      background: #5c5c5c;
      border-radius: 999px;"
  >
    ${data.type}
  </div>
</div>

`,
    zIndex: 1,
  });
};

export const customMarkerSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="36" height="46" viewBox="0 0 36 46" fill="none">
  <g clip-path="url(#clip0_1902_40962)">
    <mask id="mask0_1902_40962" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="36" height="46">
      <path d="M36 0H0V46H36V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_1902_40962)">
      <path d="M34.3813 16.1787L34.3815 16.1797C34.816 19.5878 34.0064 23.1005 32.5661 26.4544C31.128 29.8033 29.1001 32.9031 27.2144 35.4467L27.2126 35.4492C24.2183 39.506 20.9702 42.3977 18.4122 44.3455C18.155 44.5408 17.8214 44.5337 17.584 44.351L17.5781 44.3465C15.0199 42.3988 11.7711 39.5067 8.77629 35.4492L8.77555 35.4482C6.89439 32.904 4.86873 29.804 3.43164 26.4548C1.99246 23.1007 1.18288 19.5878 1.61738 16.1797L1.61751 16.1787C2.51203 9.12395 8.78068 1.5 17.9994 1.5C27.2182 1.5 33.4868 9.12395 34.3813 16.1787Z" fill="#00C46F" stroke="white" stroke-width="3"/>
      <path d="M18 26C22.4183 26 26 22.4183 26 18C26 13.5817 22.4183 10 18 10C13.5817 10 10 13.5817 10 18C10 22.4183 13.5817 26 18 26Z" fill="white"/>
    </g>
  </g>
  <defs>
    <clipPath id="clip0_1902_40962">
      <rect width="36" height="46" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

export const trafficMakersSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
  <g clip-path="url(#clip0_2716_72692)">
    <mask id="mask0_2716_72692" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="33">
      <path d="M32 0.175781H0V32.1758H32V0.175781Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_2716_72692)">
      <path d="M16 30.1758C23.732 30.1758 30 23.9078 30 16.1758C30 8.44379 23.732 2.17578 16 2.17578C8.26801 2.17578 2 8.44379 2 16.1758C2 23.9078 8.26801 30.1758 16 30.1758Z" fill="#3396FF"/>
      <path d="M16 3.17578C23.17 3.17578 29 9.00578 29 16.1758C29 23.3458 23.17 29.1758 16 29.1758C8.83 29.1758 3 23.3458 3 16.1758C3 9.00578 8.83 3.17578 16 3.17578ZM16 2.17578C8.27 2.17578 2 8.44578 2 16.1758C2 23.9058 8.27 30.1758 16 30.1758C23.73 30.1758 30 23.9058 30 16.1758C30 8.44578 23.73 2.17578 16 2.17578Z" fill="#227DD1"/>
      <path d="M21.64 10.506C21.4 9.96598 20.86 9.62598 20.26 9.62598H11.74C11.14 9.62598 10.6 9.97598 10.36 10.506L8.62 14.446C8.54 14.626 8.5 14.826 8.5 15.016V21.996C8.5 22.396 8.84 22.726 9.25 22.726H10.75C11.16 22.726 11.5 22.396 11.5 21.996V21.266H20.5V21.996C20.5 22.396 20.84 22.726 21.25 22.726H22.75C23.16 22.726 23.5 22.396 23.5 21.996V15.016C23.5 14.816 23.46 14.626 23.38 14.446L21.64 10.506ZM12.04 12.206C12.17 11.956 12.43 11.806 12.71 11.806H19.28C19.56 11.806 19.82 11.966 19.95 12.206L21.24 14.716H10.74L12.03 12.206H12.04ZM11.5 19.086C10.67 19.086 10 18.436 10 17.626C10 16.816 10.67 16.166 11.5 16.166C12.33 16.166 13 16.816 13 17.626C13 18.436 12.33 19.086 11.5 19.086ZM19 17.626C19 16.826 19.67 16.166 20.5 16.166C21.33 16.166 22 16.816 22 17.626C22 18.436 21.33 19.086 20.5 19.086C19.67 19.086 19 18.436 19 17.626Z" fill="white"/>
    </g>
  </g>
  <defs>
    <clipPath id="clip0_2716_72692">
      <rect width="32" height="32" fill="white" transform="translate(0 0.175781)"/>
    </clipPath>
  </defs>
</svg>`;

export const schoolMarkesSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
  <g clip-path="url(#clip0_2716_72711)">
    <mask id="mask0_2716_72711" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="33">
      <path d="M32 0.175781H0V32.1758H32V0.175781Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_2716_72711)">
      <path d="M16 30.1758C23.732 30.1758 30 23.9078 30 16.1758C30 8.44379 23.732 2.17578 16 2.17578C8.26801 2.17578 2 8.44379 2 16.1758C2 23.9078 8.26801 30.1758 16 30.1758Z" fill="#FFB301"/>
      <path d="M16 3.17578C23.17 3.17578 29 9.00578 29 16.1758C29 23.3458 23.17 29.1758 16 29.1758C8.83 29.1758 3 23.3458 3 16.1758C3 9.00578 8.83 3.17578 16 3.17578ZM16 2.17578C8.27 2.17578 2 8.44578 2 16.1758C2 23.9058 8.27 30.1758 16 30.1758C23.73 30.1758 30 23.9058 30 16.1758C30 8.44578 23.73 2.17578 16 2.17578Z" fill="#D89000"/>
      <path d="M18.35 9.73566L16 8.30566V11.1757L18.35 9.73566Z" fill="white"/>
      <path d="M21.5 16.1758H10.5C9.95 16.1758 9.5 16.6258 9.5 17.1758V22.1758H14.5V19.1758H17.5V22.1758H22.5V17.1758C22.5 16.6258 22.05 16.1758 21.5 16.1758Z" fill="white"/>
      <path d="M16 11.1758L12.5 14.1758V16.1758H19.5V14.1758L16 11.1758ZM17 15.1758H15V14.1758H17V15.1758Z" fill="white"/>
    </g>
  </g>
  <defs>
    <clipPath id="clip0_2716_72711">
      <rect width="32" height="32" fill="white" transform="translate(0 0.175781)"/>
    </clipPath>
  </defs>
</svg>`;

export const publicOfficeMarkesSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
  <g clip-path="url(#clip0_2716_72739)">
    <mask id="mask0_2716_72739" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="33">
      <path d="M32 0.175781H0V32.1758H32V0.175781Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_2716_72739)">
      <path d="M16 30.1758C23.732 30.1758 30 23.9078 30 16.1758C30 8.44379 23.732 2.17578 16 2.17578C8.26801 2.17578 2 8.44379 2 16.1758C2 23.9078 8.26801 30.1758 16 30.1758Z" fill="#FF7E1B"/>
      <path d="M16 3.17578C23.17 3.17578 29 9.00578 29 16.1758C29 23.3458 23.17 29.1758 16 29.1758C8.83 29.1758 3 23.3458 3 16.1758C3 9.00578 8.83 3.17578 16 3.17578ZM16 2.17578C8.27 2.17578 2 8.44578 2 16.1758C2 23.9058 8.27 30.1758 16 30.1758C23.73 30.1758 30 23.9058 30 16.1758C30 8.44578 23.73 2.17578 16 2.17578Z" fill="#CC5E15"/>
      <path d="M20 10.1758H12C10.9 10.1758 10 11.0758 10 12.1758V22.1758H14.5V19.1758H17.5V22.1758H22V12.1758C22 11.0758 21.1 10.1758 20 10.1758ZM19 17.1758H13V15.1758H19V17.1758ZM19 14.1758H13V12.1758H19V14.1758Z" fill="white"/>
    </g>
  </g>
  <defs>
    <clipPath id="clip0_2716_72739">
      <rect width="32" height="32" fill="white" transform="translate(0 0.175781)"/>
    </clipPath>
  </defs>
</svg>`;

export const hospitalMarkesSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
  <g clip-path="url(#clip0_2716_72755)">
    <mask id="mask0_2716_72755" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="33">
      <path d="M32 0.175781H0V32.1758H32V0.175781Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_2716_72755)">
      <path d="M16 30.1758C23.732 30.1758 30 23.9078 30 16.1758C30 8.44379 23.732 2.17578 16 2.17578C8.26801 2.17578 2 8.44379 2 16.1758C2 23.9078 8.26801 30.1758 16 30.1758Z" fill="#FE639F"/>
      <path d="M16 3.17578C23.17 3.17578 29 9.00578 29 16.1758C29 23.3458 23.17 29.1758 16 29.1758C8.83 29.1758 3 23.3458 3 16.1758C3 9.00578 8.83 3.17578 16 3.17578ZM16 2.17578C8.27 2.17578 2 8.44578 2 16.1758C2 23.9058 8.27 30.1758 16 30.1758C23.73 30.1758 30 23.9058 30 16.1758C30 8.44578 23.73 2.17578 16 2.17578Z" fill="#D8397A"/>
      <path d="M20.5 9.67578H11.5C10.4 9.67578 9.5 10.5758 9.5 11.6758V20.6758C9.5 21.7758 10.4 22.6758 11.5 22.6758H20.5C21.6 22.6758 22.5 21.7758 22.5 20.6758V11.6758C22.5 10.5758 21.6 9.67578 20.5 9.67578ZM20 17.4258H17.25V20.1758H14.75V17.4258H12V14.9258H14.75V12.1758H17.25V14.9258H20V17.4258Z" fill="white"/>
    </g>
  </g>
  <defs>
    <clipPath id="clip0_2716_72755">
      <rect width="32" height="32" fill="white" transform="translate(0 0.175781)"/>
    </clipPath>
  </defs>
</svg>`;

export const makeMarkers = (
  data: any,
  kakao: any,
  setMarkerDetail?: any,
  markerDetail?: any,
) => {
  if (data.type === 'A') {
    return AuctionMarker(data, kakao, setMarkerDetail);
  } else if (data.type === 'P') {
    return PAuctionMarker(data, kakao, setMarkerDetail);
  } else if (data.type === '예정') {
    return PlannedPropertyMarker(data, kakao, setMarkerDetail);
  } else if (data.type === '매물') {
    return SaleItemMarker(data, kakao, setMarkerDetail);
  } else {
    return RealDealMarker(data, kakao, setMarkerDetail);
  }
};

const AuctionMarker = (data: any, kakao: any, setMarkerDetail: any) => {
  const markerId = `marker-${data.iidx}`;
  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.lat, data.lng),
    clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
    xAnchor: 0.5,
    yAnchor: 1.0,
    content: `
    <div style="position: relative, user-select: none;">
  <div 
    id="${markerId}" 
    style="
      width: 98px;
      height: 100%; 
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      display: inline-flex;
      position:relative;
      user-select: none;
    "
  >
    <div 
      style="
      position:absolute;
      top: -17px;
        padding-left: 8px; 
        padding-right: 8px; 
        background: #F45551; 
        border-radius: 999px; 
        justify-content: center; 
        align-items: center; 
        gap: 10px; 
        display: inline-flex;
        z-index: 1;
      "
    >
      <div 
        style="
          color: white; 
          font-size: 13px; 
          font-family: Spoqa Han Sans Neo; 
          font-weight: 500; 
          line-height: 18.85px; 
          word-wrap: break-word
        "
      >
        경매
      </div>
    </div>
    <div 
      style="
        flex-direction: column; 
        justify-content: center; 
        align-items: center; 
        display: flex;
        position: relative;
      "
    >
      <div 
        style="
          align-self: stretch; 
          height: 50px; 
          flex-direction: column; 
          justify-content: flex-start; 
          align-items: center; 
          display: flex
        "
      >
        <div 
          style="
            padding-left: 12px; 
            padding-right: 12px; 
            background: white; 
            border-radius: 9999px; 
            border: 1px #008AFF solid; 
            flex-direction: column; 
            justify-content: center; 
            align-items: center; 
            display: flex
          "
        >
          <div 
            style="
              color: #008AFF; 
              font-size: 15px; 
              font-family: Spoqa Han Sans Neo; 
              font-weight: 700; 
              line-height: 21.75px; 
              word-wrap: break-word
            "
          >
            ${transNum(data.prc)}
          </div>
          <div 
            style="
              color: #616161; 
              font-size: 12px; 
              font-family: Spoqa Han Sans Neo; 
              font-weight: 500; 
              line-height: 17.40px; 
              word-wrap: break-word
            "
          >
            ${data.date}
          </div>
        </div>
        <div style="display: flex; justify-content: center; align-items: flex-start; position:absolute; left:34%; bottom:2px ; z-index: 1">
     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" fill="none">
        <!-- 삼각형 -->
        <path d="M4 1.5H2.91289L3.62037 2.3254L8.86111 8.4396C9.45976 9.13801 10.5402 9.13801 11.1389 8.4396L16.3796 2.3254L17.0871 1.5H16H4Z" fill="white" stroke="#008AFF" />
        <!-- 윗부분을 가리기 위한 선 (삼각형 뒤에 위치하도록) -->
        <rect y="0" width="20" height="2.3" fill="white" />
    </svg>
    </div>
      </div>
      <div 
        style="
        position: absolute;
        top: 43px;
          width: 8px; 
          height: 8px; 
          background: #008AFF; 
          box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08); 
          border-radius: 9999px; 
          border: 1px white solid
          
        "
      ></div>
    </div>
  </div>
</div>
  `,
    zIndex: 1,
  });

  // setTimeout을 사용해 DOM이 완전히 렌더링된 후 이벤트 리스너를 추가
  setTimeout(() => {
    const markerElement = document.getElementById(markerId);
    if (markerElement) {
      markerElement.addEventListener('click', () => {
        onCLickMarker(
          data.type,
          data.iidx,
          data.lat,
          data.lng,
          data.category,
          data.prc,
          data.date,
          kakao,
          setMarkerDetail,
        );
        overlay.setMap(null);
      });
    }
  }, 0); // DOM이 렌더링된 후 바로 이벤트 리스너를 추가

  return overlay;
};

const PAuctionMarker = (data: any, kakao: any, setMarkerDetail: any) => {
  const markerId = `marker-${data.iidx}`;
  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.lat, data.lng),
    clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
    xAnchor: 0.5,
    yAnchor: 1.0,
    content: `
    <div style="position: relative, user-select: none;">
  <div 
    id="${markerId}" 
    style="
      width: 98px;
      height: 100%; 
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      display: inline-flex;
      position:relatice;
      user-select: none;
    "
  >
    <div 
      style="
      position:absolute;
      top: -17px;
        padding-left: 8px; 
        padding-right: 8px; 
        background: #235BC6; 
        border-radius: 999px; 
        justify-content: center; 
        align-items: center; 
        gap: 10px; 
        display: inline-flex;
        z-index: 1;
      "
    >
      <div 
        style="
          color: white; 
          font-size: 13px; 
          font-family: Spoqa Han Sans Neo; 
          font-weight: 500; 
          line-height: 18.85px; 
          word-wrap: break-word
        "
      >
        공매
      </div>
    </div>
    <div 
      style="
        flex-direction: column; 
        justify-content: center; 
        align-items: center; 
        display: flex;
        position: relative;
      "
    >
      <div 
        style="
          align-self: stretch; 
          height: 50px; 
          flex-direction: column; 
          justify-content: flex-start; 
          align-items: center; 
          display: flex
        "
      >
        <div 
          style="
            padding-left: 12px; 
            padding-right: 12px; 
            background: white; 
            border-radius: 9999px; 
            border: 1px #008AFF solid; 
            flex-direction: column; 
            justify-content: center; 
            align-items: center; 
            display: flex
          "
        >
          <div 
            style="
              color: #008AFF; 
              font-size: 15px; 
              font-family: Spoqa Han Sans Neo; 
              font-weight: 700; 
              line-height: 21.75px; 
              word-wrap: break-word
            "
          >
            ${transNum(data.prc)}
          </div>
          <div 
            style="
              color: #616161; 
              font-size: 12px; 
              font-family: Spoqa Han Sans Neo; 
              font-weight: 500; 
              line-height: 17.40px; 
              word-wrap: break-word
            "
          >
            ${data.date}
          </div>
        </div>
        <div style="display: flex; justify-content: center; align-items: flex-start; position:absolute; left:34%; bottom:2px ; z-index: 1">
     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" fill="none">
        <!-- 삼각형 -->
        <path d="M4 1.5H2.91289L3.62037 2.3254L8.86111 8.4396C9.45976 9.13801 10.5402 9.13801 11.1389 8.4396L16.3796 2.3254L17.0871 1.5H16H4Z" fill="white" stroke="#008AFF" />
        <!-- 윗부분을 가리기 위한 선 (삼각형 뒤에 위치하도록) -->
        <rect y="0" width="20" height="2.3" fill="white" />
    </svg>
    </div>
      </div>
      <div 
        style="
        position: absolute;
        top: 43px;
          width: 8px; 
          height: 8px; 
          background: #008AFF; 
          box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08); 
          border-radius: 9999px; 
          border: 1px white solid
          
        "
      ></div>
    </div>
  </div>
</div>
  `,
    zIndex: 1,
  });

  // setTimeout을 사용해 DOM이 완전히 렌더링된 후 이벤트 리스너를 추가
  setTimeout(() => {
    const markerElement = document.getElementById(markerId);
    if (markerElement) {
      markerElement.addEventListener('click', () => {
        onCLickMarker(
          data.type,
          data.iidx,
          data.lat,
          data.lng,
          data.category,
          data.prc,
          data.date,
          kakao,
          setMarkerDetail,
        );
        overlay.setMap(null);
      });
    }
  }, 0); // DOM이 렌더링된 후 바로 이벤트 리스너를 추가

  return overlay;
};

const PlannedPropertyMarker = (data: any, kakao: any, setMarkerDetail: any) => {
  const markerId = `marker-${data.iidx}`;
  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.lat, data.lng),
    clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
    xAnchor: 0.5,
    yAnchor: 1.0,
    content: `
    <div style="position: relative, user-select: none;">
  <div 
    id="${markerId}" 
    style="
      width: 98px;
      height: 100%; 
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      display: inline-flex;
      position:relatice;
      user-select: none;
    "
  >
    <div 
      style="
      position:absolute;
      top: -17px;
        padding-left: 8px; 
        padding-right: 8px; 
        background: #E59100; 
        border-radius: 999px; 
        justify-content: center; 
        align-items: center; 
        gap: 10px; 
        display: inline-flex;
        z-index: 1;
      "
    >
      <div 
        style="
          color: white; 
          font-size: 13px; 
          font-family: Spoqa Han Sans Neo; 
          font-weight: 500; 
          line-height: 18.85px; 
          word-wrap: break-word
        "
      >
        예정
      </div>
    </div>
    <div 
      style="
        flex-direction: column; 
        justify-content: center; 
        align-items: center; 
        display: flex;
        position: relative;
      "
    >
      <div 
        style="
          align-self: stretch; 
          height: 50px; 
          flex-direction: column; 
          justify-content: flex-start; 
          align-items: center; 
          display: flex
        "
      >
        <div 
          style="
            padding-left: 12px; 
            padding-right: 12px; 
            background: white; 
            border-radius: 9999px; 
            border: 1px #008AFF solid; 
            flex-direction: column; 
            justify-content: center; 
            align-items: center; 
            display: flex
          "
        >
          <div 
            style="
              color: #008AFF; 
              font-size: 15px; 
              font-family: Spoqa Han Sans Neo; 
              font-weight: 700; 
              line-height: 21.75px; 
              word-wrap: break-word
            "
          >
            ${'접수'}
          </div>
          <div 
            style="
              color: #616161; 
              font-size: 12px; 
              font-family: Spoqa Han Sans Neo; 
              font-weight: 500; 
              line-height: 17.40px; 
              word-wrap: break-word
            "
          >
            ${data.date}
          </div>
        </div>
        <div style="display: flex; justify-content: center; align-items: flex-start; position:absolute; left:34%; bottom:2px ; z-index: 1">
     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" fill="none">
        <!-- 삼각형 -->
        <path d="M4 1.5H2.91289L3.62037 2.3254L8.86111 8.4396C9.45976 9.13801 10.5402 9.13801 11.1389 8.4396L16.3796 2.3254L17.0871 1.5H16H4Z" fill="white" stroke="#008AFF" />
        <!-- 윗부분을 가리기 위한 선 (삼각형 뒤에 위치하도록) -->
        <rect y="0" width="20" height="2.3" fill="white" />
    </svg>
    </div>
      </div>
      <div 
        style="
        position: absolute;
        top: 43px;
          width: 8px; 
          height: 8px; 
          background: #008AFF; 
          box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08); 
          border-radius: 9999px; 
          border: 1px white solid
          
        "
      ></div>
    </div>
  </div>
</div>
  `,
    zIndex: 1,
  });

  // setTimeout을 사용해 DOM이 완전히 렌더링된 후 이벤트 리스너를 추가
  setTimeout(() => {
    const markerElement = document.getElementById(markerId);
    if (markerElement) {
      markerElement.addEventListener('click', () => {
        onCLickMarker(
          data.type,
          data.iidx,
          data.lat,
          data.lng,
          data.category,
          data.prc,
          data.date,
          kakao,
          setMarkerDetail,
        );
        overlay.setMap(null);
      });
    }
  }, 0); // DOM이 렌더링된 후 바로 이벤트 리스너를 추가

  return overlay;
};
const SaleItemMarker = (data: any, kakao: any, setMarkerDetail: any) => {
  const markerId = `marker-${data.iidx}`;
  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.lat, data.lng),
    clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
    xAnchor: 0.5,
    yAnchor: 1.0,
    content: `
    <div style="position: relative, user-select: none;">
  <div 
    id="${markerId}" 
    style="
      width: 98px;
      height: 100%; 
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      display: inline-flex;
      position:relatice;
      user-select: none;
    "
  >
    <div 
      style="
      position:absolute;
      top: -17px;
        padding-left: 8px; 
        padding-right: 8px; 
        background: #34A353; 
        border-radius: 999px; 
        justify-content: center; 
        align-items: center; 
        gap: 10px; 
        display: inline-flex;
        z-index: 1;
      "
    >
      <div 
        style="
          color: white; 
          font-size: 13px; 
          font-family: Spoqa Han Sans Neo; 
          font-weight: 500; 
          line-height: 18.85px; 
          word-wrap: break-word
        "
      >
        매물
      </div>
    </div>
    <div 
      style="
        flex-direction: column; 
        justify-content: center; 
        align-items: center; 
        display: flex;
        position: relative;
      "
    >
      <div 
        style="
          align-self: stretch; 
          height: 50px; 
          flex-direction: column; 
          justify-content: flex-start; 
          align-items: center; 
          display: flex
        "
      >
        <div 
          style="
            padding-left: 12px; 
            padding-right: 12px; 
            background: white; 
            border-radius: 9999px; 
            border: 1px #008AFF solid; 
            flex-direction: column; 
            justify-content: center; 
            align-items: center; 
            display: flex
          "
        >
          <div 
            style="
              color: #008AFF; 
              font-size: 15px; 
              font-family: Spoqa Han Sans Neo; 
              font-weight: 700; 
              line-height: 21.75px; 
              word-wrap: break-word
            "
          >
            ${'접수'}
          </div>
          <div 
            style="
              color: #616161; 
              font-size: 12px; 
              font-family: Spoqa Han Sans Neo; 
              font-weight: 500; 
              line-height: 17.40px; 
              word-wrap: break-word
            "
          >
            ${data.date}
          </div>
        </div>
        <div style="display: flex; justify-content: center; align-items: flex-start; position:absolute; left:34%; bottom:2px ; z-index: 1">
     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" fill="none">
        <!-- 삼각형 -->
        <path d="M4 1.5H2.91289L3.62037 2.3254L8.86111 8.4396C9.45976 9.13801 10.5402 9.13801 11.1389 8.4396L16.3796 2.3254L17.0871 1.5H16H4Z" fill="white" stroke="#008AFF" />
        <!-- 윗부분을 가리기 위한 선 (삼각형 뒤에 위치하도록) -->
        <rect y="0" width="20" height="2.3" fill="white" />
    </svg>
    </div>
      </div>
      <div 
        style="
        position: absolute;
        top: 43px;
          width: 8px; 
          height: 8px; 
          background: #008AFF; 
          box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08); 
          border-radius: 9999px; 
          border: 1px white solid
          
        "
      ></div>
    </div>
  </div>
</div>
  `,
    zIndex: 1,
  });

  // setTimeout을 사용해 DOM이 완전히 렌더링된 후 이벤트 리스너를 추가
  setTimeout(() => {
    const markerElement = document.getElementById(markerId);
    if (markerElement) {
      markerElement.addEventListener('click', () => {
        onCLickMarker(
          data.type,
          data.iidx,
          data.lat,
          data.lng,
          data.category,
          data.prc,
          data.date,
          kakao,
          setMarkerDetail,
        );
        overlay.setMap(null);
      });
    }
  }, 0); // DOM이 렌더링된 후 바로 이벤트 리스너를 추가

  return overlay;
};

function onCLickMarker(
  type: string,
  iidx: string,
  lat: number,
  lng: number,
  category: string,
  prc: number,
  date: string,
  kakao: any,
  setMarkerDetail: any,
) {
  setMarkerDetail({
    type: type.trim(),
    iidx: iidx,
    category: category,
    prc: prc,
    date: date,
    lat: lat,
    lng: lng,
  });
}

const RealDealMarker = (data: any, kakao: any, setMarkerDetail?: any) => {
  if (!setMarkerDetail) {
    console.log('no', data.iidx);
  }

  const markerId = `marker-${data.iidx}`;
  const itemType = (type: string) => {
    const clearType = type.trim();
    if (clearType === 'D') {
      return '전세';
    } else if (clearType === 'M') {
      return '월';
    } else {
      return '매매';
    }
  };

  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.lat, data.lng),
    clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
    xAnchor: 0.5, // x축 기준점 (0 = 왼쪽, 0.5 = 중앙, 1 = 오른쪽)
    yAnchor: 1,
    content: `
    <div style="position: relative">
  <div 
    id="${markerId}" 
    style="
      width: 98px;
      height: 100%; 
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      display: inline-flex;
      position:relative;
      user-select: none;
    "
    >
    <div 
      style="
        flex-direction: column; 
        justify-content: center; 
        align-items: center; 
        display: flex;
        position: relative;
      "
    >
      <div 
        style="
          align-self: stretch; 
          height: 50px; 
          flex-direction: column; 
          justify-content: flex-start; 
          align-items: center; 
          display: flex
        "
      >
        <div 
          style="
            padding-left: 12px; 
            padding-right: 12px; 
            background: white; 
            border-radius: 9999px; 
            border: 1px ${getColorByCategory(data.category).color} solid; 
            flex-direction: column; 
            justify-content: center; 
            align-items: center; 
            display: flex
          "
        >
          <div
          style="
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          gap:2px;
          "
          >
            <img src=${getColorByCategory(data.category).icon} style="width: 20px; height: 20px;" ></img>
              <div 
              style="
              color: ${getColorByCategory(data.category).color}; 
              font-size: 13px; 
              font-family: Spoqa Han Sans Neo; 
                  font-weight: 700; 
                  line-height: 21.75px; 
                  word-wrap: break-word
                "
              >
                ${itemType(data.type)}${transNum(data.prc)}
              </div>
          </div>
          <div 
            style="
              color: #616161; 
              font-size: 11px; 
              font-family: Spoqa Han Sans Neo; 
              font-weight: 500; 
              line-height: 17.40px; 
              word-wrap: break-word
            "
          >
            ${data.date}
          </div>
        </div>
        <div style="display: flex; justify-content: center; align-items: flex-start; position:absolute; left:39%; bottom:2px ; z-index: 1">
     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" fill="none">
        <!-- 삼각형 -->
        <path d="M4 1.5H2.91289L3.62037 2.3254L8.86111 8.4396C9.45976 9.13801 10.5402 9.13801 11.1389 8.4396L16.3796 2.3254L17.0871 1.5H16H4Z" fill="white" stroke="${getColorByCategory(data.category).color}" />
        <!-- 윗부분을 가리기 위한 선 (삼각형 뒤에 위치하도록) -->
        <rect y="0" width="20" height="2.3" fill="white" />
    </svg>
    </div>
      </div>
      <div 
        style="
        position: absolute;
        top: 43px;
          width: 8px; 
          height: 8px; 
          background: ${getColorByCategory(data.category).color}; 
          box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08); 
          border-radius: 9999px; 
          border: 1px white solid
          
        "
      ></div>
    </div>
  </div>
</div>
  `,
    zIndex: 1,
  });

  // setTimeout을 사용해 DOM이 완전히 렌더링된 후 이벤트 리스너를 추가
  setTimeout(() => {
    const markerElement = document.getElementById(markerId);
    if (markerElement) {
      markerElement.addEventListener(
        'click',
        () => {
          onCLickMarker(
            data.type,
            data.iidx,
            data.lat,
            data.lng,
            data.category,
            data.prc,
            data.date,
            kakao,
            setMarkerDetail,
          );
          overlay.setMap(null);
        },
        { passive: true }, // 이벤트 리스너에 passive 옵션 추가
      );
    }
  }, 0); // DOM이 렌더링된 후 바로 이벤트 리스너를 추가

  return overlay;
};

export const DetailMarkers = (
  data: any,
  kakao: any,
  lat: number,
  lng: number,
  setOnRealDealList: any,
  setIidx: any,
  setModalOn: any,
  setMarkerType: any,
  setMarkerCategory: any,
) => {
  if (data.type === 'a') {
    return AuctionDetailMarker(
      data,
      kakao,
      lat,
      lng,
      setOnRealDealList,
      setIidx,
      setModalOn,
      setMarkerType,
      setMarkerCategory,
    );
  } else if (data.type === 'p') {
    return PAuctionDetailMarker(
      data,
      kakao,
      lat,
      lng,
      setOnRealDealList,
      setIidx,
      setModalOn,
      setMarkerType,
      setMarkerCategory,
    );
  } else if (data.type === '예정') {
    return PlannedPropertyDetailMarker(data, kakao, lat, lng);
  } else {
    return RealDealDetailMarker(
      data,
      kakao,
      lat,
      lng,
      setOnRealDealList,
      setIidx,
      setModalOn,
      setMarkerType,
      setMarkerCategory,
    );
  }
};

const PlannedPropertyDetailMarker = (
  data: any,
  kakao: any,
  lat: number,
  lng: number,
) => {
  const markerId = `marker-detail-${data.iidx}`;
  const itemType = (type: string, price: number, m_price?: number) => {
    if (type === 'D') {
      return { type: '전세', price: `${transNum(price)}` };
    } else if (type === 'M') {
      return {
        type: '월세',
        price: `${transNum(price)} / ${transNum(m_price ?? 0)}`,
      };
    } else {
      return { type: '매매', price: `${transNum(price)}` };
    }
  };

  const markerData = itemType(data.type, data.price, data.m_price);
  const markerColorText = getColorByCategory(data.category);

  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(lat, lng),
    clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
    xAnchor: 0.5, // x축 기준점 (0 = 왼쪽, 0.5 = 중앙, 1 = 오른쪽)
    yAnchor: 1,
    content: `
  <div style="position: relative">
    <div id="${markerId}" style="width: 100%; height: 100%; flex-direction: column; justify-content: center; align-items: center; display: inline-flex; position:relative; user-select: none;">
      <div style="align-self: stretch; height: 80px; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08); flex-direction: column; justify-content: flex-start; align-items: center; display: flex; position: relative;">
        <div style="background: ${markerColorText.color}; border-radius: 8px; justify-content: flex-start; align-items: center; display: inline-flex; flex-direction: row;">
          <div style="align-self: stretch; padding: 2px 10px; background: white; border-top-left-radius: 8px; border-bottom-left-radius: 8px; border: 1px ${markerColorText.color} solid; flex-direction: column; justify-content: center; align-items: center; display: inline-flex;">
            <div style="width: 16px; height: 16px; position: relative;">
              ${PlannedDetailIcon(markerColorText.color)}
            </div>
            <div style="text-align: center; color: ${markerColorText.color}; font-size: 12px; font-family: Spoqa Han Sans Neo; font-weight: 700; line-height: 17.40px; word-wrap: break-word;">예정</div>
          </div>
          <div style="padding: 5px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 1px; display: inline-flex;">
            <div style="padding: 0 6px; background: white; border-radius: 9999px; justify-content: center; align-items: center; gap: 10px; display: inline-flex;">
              <div style="color: ${markerColorText.color}; font-size: 12px; font-family: Spoqa Han Sans Neo; font-weight: 700; line-height: 17.40px; word-wrap: break-word;">${'2024타경 118932'}</div>
            </div>
            <div style="padding-right: 10px; border-radius: 9999px; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex;">
              <div style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex;">
                <div style="color: white; font-size: 15px; font-family: Spoqa Han Sans Neo; font-weight: 700; line-height: 21.75px; word-wrap: break-word;">${'접수 24.10.28'}</div>
                <div style="color: rgba(255, 255, 255, 0.78); font-size: 12px; font-family: Spoqa Han Sans Neo; font-weight: 500; line-height: 17.40px; word-wrap: break-word;">${'개시 24.10.15'}</div>
              </div>
              <div style="color: rgba(255, 255, 255, 0.78); font-size: 12px; font-family: Spoqa Han Sans Neo; font-weight: 500; line-height: 17.40px; word-wrap: break-word;">${'배당종기 25.01.17'}</div>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: center; align-items: flex-start; position:absolute; left:45.5%; bottom:-14px ; z-index: 1;">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" fill="none">
            <path d="M4 1.5H2.91289L3.62037 2.3254L8.86111 8.4396C9.45976 9.13801 10.5402 9.13801 11.1389 8.4396L16.3796 2.3254L17.0871 1.5H16H4Z" fill="${markerColorText.color}" stroke="${markerColorText.color}" />
          </svg>
        </div>
        <div style="position: absolute; top: 89px; width: 8px; height: 8px; background: ${markerColorText.color}; box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08); border-radius: 9999px; border: 1px white solid;"></div>
      </div>
    </div>
  </div>
`,
    zIndex: 10,
  });
  // setTimeout을 사용해 DOM이 완전히 렌더링된 후 이벤트 리스너를 추가
  setTimeout(() => {
    const markerElement = document.getElementById(markerId);
    if (markerElement) {
      markerElement.addEventListener('click', () => {
        // onCLickMarker(
        //   data.type,
        //   data.iidx,
        //   data.lat,
        //   data.lng,
        //   data.category,
        //   data.prc,
        //   data.date,
        //   kakao,
        //   setMarkerDetail,
        // );
        // overlay.setMap(null);
      });
    }
  }, 0); // DOM이 렌더링된 후 바로 이벤트 리스너를 추가

  return overlay;
};

const RealDealDetailMarker = (
  data: any,
  kakao: any,
  lat: number,
  lng: number,
  setOnRealDealList: any,
  setIidx: any,
  setModalOn: any,
  setMarkerType: any,
  setMarkerCategory: any,
) => {
  const markerId = `marker-detail-${data.iidx}`;
  const realDealOnButton = `realDealOnButton-${data.iidx}`;
  const itemType = (type: string, price: number, m_price?: number) => {
    const clearType = type.trim();
    if (clearType === 'D') {
      return { type: '전세', price: `${transNum(price)}` };
    } else if (clearType === 'M') {
      return {
        type: '월세',
        price: `${transNum(price)} / ${transNum(m_price ?? 0)}`,
      };
    } else {
      return { type: '매매', price: `${transNum(price)}` };
    }
  };

  const markerData = itemType(data.type, data.price, data.m_price);
  const markerColorText = getColorByCategory(data.category);

  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(lat, lng),
    clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
    xAnchor: 0.5, // x축 기준점 (0 = 왼쪽, 0.5 = 중앙, 1 = 오른쪽)
    yAnchor: 1.0,
    content: `
  <div style="position: relative ; ">
    <div id="${markerId}" style="width: 100%; height: 100%; flex-direction: column; justify-content: center; align-items: center; display: inline-flex; position:relative; user-select: none;">
      <div style="align-self: stretch; height: 100%; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08); flex-direction: column; justify-content: flex-start; align-items: center; display: flex; position: relative;">
        <div style="background: ${markerColorText.color}; border-radius: 8px; justify-content: flex-start; align-items: center; display: inline-flex; flex-direction: row;">
          <div style="align-self: stretch; padding: 2px 10px; background: white; border-top-left-radius: 8px; border-bottom-left-radius: 8px; border: 1px ${markerColorText.color} solid; flex-direction: column; justify-content: center; align-items: center; display: inline-flex;">
            <div style="width: 16px; height: 16px; position: relative;">
              ${RealDealDetailImg(markerColorText.color)}
            </div>
            <div style="text-align: center; color: ${markerColorText.color}; font-size: 12px; font-family: Spoqa Han Sans Neo; font-weight: 700; line-height: 17.40px; word-wrap: break-word;">실거래</div>
          </div>
          <div style="padding: 5px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 1px; display: inline-flex;">
            <div style="padding: 0 6px; background: white; border-radius: 9999px; justify-content: center; align-items: center; gap: 10px; display: inline-flex;">
              <div style="color: ${markerColorText.color}; font-size: 12px; font-family: Spoqa Han Sans Neo; font-weight: 700; line-height: 17.40px; word-wrap: break-word;">${markerColorText.text}</div>
            </div>
            <div style="padding-right: 10px; border-radius: 9999px; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex;">
              <div style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex;">
                <div style="color: white; font-size: ${markerData.type === '매매' ? '13px' : '15px'}; font-family: Spoqa Han Sans Neo; font-weight: 700; line-height: 21.75px; word-wrap: break-word;">${markerData.type} ${markerData.price}</div>
                <div style="color: rgba(255, 255, 255, 0.78); font-size: 11px; font-family: Spoqa Han Sans Neo; font-weight: 500; line-height: 17.40px; word-wrap: break-word;">${data.area}</div>
              </div>
              <div style="color: rgba(255, 255, 255, 0.78); font-size: 11px; font-family: Spoqa Han Sans Neo; font-weight: 500; line-height: 17.40px; word-wrap: break-word;">계약일 ${data.date}</div>
              
              ${
                realDealButtonYN(markerColorText.text)
                  ? `<div id=${realDealOnButton} style="width: 100%; height: 100%; background: white; border-radius: 6px; justify-content: flex-start; align-items: center; display: inline-flex;   border: 1px #E1E2E4 solid; z-index:10000 ;">
                <div style="padding-left: 8px; padding-right: 8px; padding-top: 2px; padding-bottom: 2px; justify-content: center; align-items: center; gap: 4px; display: flex; flex-direction:row;">
                    <div  style="color: #616161; font-size: 13px; font-family: Spoqa Han Sans Neo; font-weight: 500; line-height: 18.85px; word-wrap: break-word">실거래가</div>
                    <div data-svg-wrapper style="position: relative">
                      <svg width="6" height="15" viewBox="0 0 6 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.775345 11.4122C0.541031 11.1843 0.541031 10.815 0.775345 10.5872L3.95108 7.49967L0.775345 4.41215C0.54103 4.18435 0.54103 3.815 0.775345 3.58719C1.00966 3.35939 1.38956 3.35939 1.62387 3.58719L5.22387 7.08719C5.45819 7.315 5.45819 7.68435 5.22387 7.91215L1.62387 11.4122C1.38956 11.64 1.00966 11.64 0.775345 11.4122Z" fill="#37383C" fill-opacity="0.61"/>
                      </svg>
                    </div>
                  </div>
              </div>`
                  : ''
              }
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: center; align-items: flex-start; position:absolute; left:46.1%; bottom:-7%; z-index: 1;">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" fill="none">
            <path d="M4 1.5H2.91289L3.62037 2.3254L8.86111 8.4396C9.45976 9.13801 10.5402 9.13801 11.1389 8.4396L16.3796 2.3254L17.0871 1.5H16H4Z" fill="${markerColorText.color}" stroke="${markerColorText.color}" />
          </svg>
        </div>
        <div style="position: absolute; top: 104%; left:50%; width: 8px; height: 8px; background: ${markerColorText.color}; box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08); border-radius: 9999px; border: 1px white solid;"></div>
      </div>
    </div>
  </div>
`,
    zIndex: 10000,
  });

  // setTimeout을 사용해 DOM이 완전히 렌더링된 후 이벤트 리스너를 추가
  setTimeout(() => {
    const markerElement = document.getElementById(realDealOnButton);

    if (markerElement) {
      markerElement.addEventListener('click', () => {
        setOnRealDealList(true);
        setIidx(data.iidx);
        setModalOn(true);
        setMarkerType(data.type);
        setMarkerCategory(data.category);
      });
    }
  }, 300); // DOM이 렌더링된 후 바로 이벤트 리스너를 추가

  return overlay;
};

const AuctionDetailMarker = (
  data: any,
  kakao: any,
  lat: number,
  lng: number,
  setOnRealDealList: any,
  setIidx: any,
  setModalOn: any,
  setMarkerType: any,
  setMarkerCategory: any,
) => {
  const markerId = `marker-detail-${data.iidx}`;

  const markerColorText = getColorByCategory(data.category);
  const uniqueId = `togglePriceBtn-${data.iidx}`;

  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(lat, lng),
    clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
    xAnchor: 0.5, // x축 기준점 (0 = 왼쪽, 0.5 = 중앙, 1 = 오른쪽)
    yAnchor: 1.0,
    content: `
  <div style="position: relative ">
    <div style="display:flex; flex-direction:row; justify-content:flex-end ; user-select: none;">
      <div id="${uniqueId}" style=" height: 28px; padding-left: 6px; padding-right: 6px; padding-top: 4px; padding-bottom: 4px; background: #F45551; border-top-left-radius: 4px; border-top-right-radius: 4px; justify-content: flex-start; align-items: center; gap: 4px; display: inline-flex; flex-direction: row;">
        <div>
          ${AuctionDetailImg('#ffffff')}
        </div>
        <div style="text-align: center; color: white; font-size: 14px; font-family: Spoqa Han Sans Neo; font-weight: 500; line-height: 20.30px; word-wrap: break-word">감정가보기</div>
      </div>
    </div>
    <div id="${markerId}" style="border-radius: 8px;  width: 100%; height: 100%; flex-direction: column; justify-content: center; align-items: center; display: inline-flex; position:relative; user-select: none;  box-shadow: 4px 8px 4px rgba(0, 0, 0, 0.08); ">
      ${RendingRealDealData('경매', data, markerColorText)}
  </div>
`,
    zIndex: 10,
  });
  // setTimeout을 사용해 DOM이 완전히 렌더링된 후 이벤트 리스너를 추가
  setTimeout(() => {
    const togglePriceBtn = document.getElementById(uniqueId);
    const realDealOnButton = document.getElementById(
      `realDealOnButton-${data.iidx}`,
    );
    const detailOnButton = document.getElementById(
      `detailOnButton-${data.iidx}`,
    );
    // const detailOnButton = `detailOnButton-${data.iidx}`;
    if (togglePriceBtn) {
      togglePriceBtn.addEventListener('click', () => {
        // 이미지와 텍스트를 변경
        const imageElement = togglePriceBtn.querySelector('div');
        const textElement = togglePriceBtn.querySelector('div:nth-child(2)');
        const markerElement = document.getElementById(markerId);

        if (
          imageElement &&
          textElement &&
          markerElement &&
          textElement.textContent?.includes('감정가보기')
        ) {
          togglePriceBtn.style.background = '#989BA2';
          // 이미지 변경
          imageElement.innerHTML = `${RealDealViewIcon('#ffffff')}`;

          // 텍스트 변경
          textElement.textContent = '실거래가 보기';
          //본문 변경
          markerElement.innerHTML = `${RendiingAppraisalData('경매', data, markerColorText)}`;
        } else {
          if (!imageElement || !textElement || !markerElement) {
            return;
          }
          togglePriceBtn.style.background = '#F45551';
          // 이미지 변경
          imageElement.innerHTML = `${AuctionDetailImg('#ffffff')}`;

          // 텍스트 변경
          textElement.textContent = '감정가보기';
          //본문 변경
          markerElement.innerHTML = `${RendingRealDealData('경매', data, markerColorText)}`;

          const detailOnButton = document.getElementById(
            `detailOnButton-${data.iidx}`,
          );

          if (detailOnButton) {
            detailOnButton.addEventListener('click', () => {
              window.open(`/auction/detail/${data.iidx}`, '_blank');
            });
          }

          const realDealOnButton = document.getElementById(
            `realDealOnButton-${data.iidx}`,
          );

          if (realDealOnButton) {
            realDealOnButton.addEventListener('click', () => {
              setOnRealDealList(true);
              setIidx(data.iidx);
              setModalOn(true);
              setMarkerType(data.type);
              setMarkerCategory(data.category);
            });
          }
        }
      });
    }

    if (realDealOnButton) {
      realDealOnButton.addEventListener('click', () => {
        setOnRealDealList(true);
        setIidx(data.iidx);
        setModalOn(true);
        setMarkerType(data.type);
        setMarkerCategory(data.category);
      });
    }
    if (detailOnButton) {
      detailOnButton.addEventListener('click', () => {
        window.open(`/auction/detail/${data.iidx}`, '_blank');
      });
    }
  }, 300); // DOM이 렌더링된 후 바로 이벤트 리스너를 추가
  return overlay;
};

const PAuctionDetailMarker = (
  data: any,
  kakao: any,
  lat: number,
  lng: number,
  setOnRealDealList: any,
  setIidx: any,
  setModalOn: any,
  setMarkerType: any,
  setMarkerCategory: any,
) => {
  const markerId = `marker-detail-${data.iidx}`;

  const markerColorText = getColorByCategory(data.category);
  const uniqueId = `togglePriceBtn-${data.iidx}`;
  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(lat, lng),
    clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
    xAnchor: 0.5, // x축 기준점 (0 = 왼쪽, 0.5 = 중앙, 1 = 오른쪽)
    yAnchor: 1,
    content: `
  <div style="position: relative ">
    <div style="display:flex; flex-direction:row; justify-content:flex-end ; user-select: none;">
      <div id="${uniqueId}" style=" height: 28px; padding-left: 6px; padding-right: 6px; padding-top: 4px; padding-bottom: 4px; background: #F45551; border-top-left-radius: 4px; border-top-right-radius: 4px; justify-content: flex-start; align-items: center; gap: 4px; display: inline-flex; flex-direction: row;">
        <div>
          ${PauctionDetailImg('#ffffff')}
        </div>
        <div style="text-align: center; color: white; font-size: 14px; font-family: Spoqa Han Sans Neo; font-weight: 500; line-height: 20.30px; word-wrap: break-word">
          감정가보기
        </div>
      </div>
    </div>
    <div id="${markerId}" style="border-radius: 8px;  width: 100%; height: 100%; flex-direction: column; justify-content: center; align-items: center; display: inline-flex; position:relative; user-select: none;  box-shadow: 4px 8px 4px rgba(0, 0, 0, 0.08); ">
      ${RendingRealDealData('공매', data, markerColorText)}
  </div>
`,
    zIndex: 10,
  });
  // setTimeout을 사용해 DOM이 완전히 렌더링된 후 이벤트 리스너를 추가
  setTimeout(() => {
    const togglePriceBtn = document.getElementById(uniqueId);

    const detailOnButton = document.getElementById(
      `detailOnButton-${data.iidx}`,
    );

    if (detailOnButton) {
      detailOnButton.addEventListener('click', () => {
        window.open(`/pauction/detail/${data.iidx}`, '_blank');
      });
    }

    const realDealOnButton = document.getElementById(
      `realDealOnButton-${data.iidx}`,
    );

    if (realDealOnButton) {
      realDealOnButton.addEventListener('click', () => {
        setOnRealDealList(true);
        setIidx(data.iidx);
        setModalOn(true);
        setMarkerType(data.type);
        setMarkerCategory(data.category);
      });
    }

    // const detailOnButton = `detailOnButton-${data.iidx}`;
    if (togglePriceBtn) {
      togglePriceBtn.addEventListener('click', () => {
        // 이미지와 텍스트를 변경
        const imageElement = togglePriceBtn.querySelector('div');
        const textElement = togglePriceBtn.querySelector('div:nth-child(2)');
        const markerElement = document.getElementById(markerId);

        if (
          imageElement &&
          textElement &&
          markerElement &&
          textElement.textContent?.includes('감정가보기')
        ) {
          togglePriceBtn.style.background = '#989BA2';

          // 이미지 변경
          imageElement.innerHTML = `${AuctionDetailImg('#ffffff')}`;

          // 텍스트 변경
          textElement.textContent = '실거래가 보기';
          //본문 변경
          markerElement.innerHTML = `${RendiingAppraisalData('공매', data, markerColorText)}`;
        } else {
          if (!imageElement || !textElement || !markerElement) {
            return;
          }
          togglePriceBtn.style.background = '#F45551';
          // 이미지 변경
          imageElement.innerHTML = `${AuctionDetailImg('#ffffff')}`;

          // 텍스트 변경
          textElement.textContent = '감정가보기';
          //본문 변경
          markerElement.innerHTML = `${RendingRealDealData('공매', data, markerColorText)}`;

          const realDealOnButton = document.getElementById(
            `realDealOnButton-${data.iidx}`,
          );
          const detailOnButton = document.getElementById(
            `detailOnButton-${data.iidx}`,
          );

          if (realDealOnButton) {
            realDealOnButton.addEventListener('click', () => {
              setOnRealDealList(true);
              setIidx(data.iidx);
              setModalOn(true);
              setMarkerType(data.type);
              setMarkerCategory(data.category);
            });
          }
          if (detailOnButton) {
            detailOnButton.addEventListener('click', () => {
              window.open(`/pauction/detail/${data.iidx}`, '_blank');
            });
          }
        }
      });
    }
  }, 300); // DOM이 렌더링된 후 바로 이벤트 리스너를 추가

  return overlay;
};

//실거래가 색상변경
export const getColorByCategory = (category: string) => {
  //"A:아파트;B:단독/다가구;C:다세대(빌라)/연립;D:빌딩/건물;E:상가;F:오피스텔;G:공장/창고;H:숙박시설;I:토지"

  switch (category) {
    case 'A':
      return {
        color: '#008AFF',
        text: '아파트',
        icon: '/assets/images/marker/basicMarker/marker_icon_apart.svg',
        pinMarker: '/assets/images/marker/apartment.svg',
      };
    case 'B':
      return {
        icon: '/assets/images/marker/basicMarker/marker_icon_home.svg',
        color: '#F1AA11',
        text: '단독/다가구',
        pinMarker: '/assets/images/marker/detachedHouse.svg',
      };
    case 'C':
      return {
        icon: '/assets/images/marker/basicMarker/marker_icon_villa.svg',
        color: '#009688',
        text: '다세대(빌라)/연립',
        pinMarker: '/assets/images/marker/townhouse.svg',
      };
    case 'D':
      return {
        icon: '/assets/images/marker/basicMarker/marker_icon_building.svg',
        color: '#F670BA',
        text: '빌딩/건물',
        pinMarker: '/assets/images/marker/building.svg',
      };
    case 'E':
      return {
        icon: '/assets/images/marker/basicMarker/marker_icon_store.svg',
        color: '#EE6900',
        text: '상가',
        pinMarker: '/assets/images/marker/downtown.svg',
      };
    case 'F':
      return {
        icon: '/assets/images/marker/basicMarker/marker_icon_officetel.svg',
        color: '#56B4E9',
        text: '오피스텔',
        pinMarker: '/assets/images/marker/officetel.svg',
      };
    case 'G':
      return {
        icon: '/assets/images/marker/basicMarker/marker_icon_factory.svg',
        color: '#515151',
        text: '공장/창고',
        pinMarker: '/assets/images/marker/factory.svg',
      };
    case 'H':
      return {
        icon: '/assets/images/marker/basicMarker/marker_icon_inn.svg',
        color: '#BA53DC',
        text: '숙박시설',
        pinMarker: '/assets/images/marker/inn.svg',
      };
    case 'I':
      return {
        icon: '/assets/images/marker/basicMarker/marker_icon_land.svg',
        color: '#16CE2E',
        text: '토지',
        pinMarker: '/assets/images/marker/land.svg',
      };
    default:
      return {
        icon: '/assets/images/marker/basicMarker/marker_icon_etc.svg',
        color: '#05455C',
        text: `기타`,
        pinMarker: '/assets/images/marker/etc.svg',
      };
  }
};

const RendiingAppraisalData = (
  type: string,
  data: any,
  markerColorText: any,
) => {
  return `
<div style="align-self: stretch; height: 80px; box-shadow: 4px 8px 4px rgba(0, 0, 0, 0.08); flex-direction: column; justify-content: flex-start; align-items: center; display: flex; position: relative;">
        <div style="background: ${'#ffffff'}; border-radius: 8px; justify-content: flex-start; align-items: center; display: inline-flex; flex-direction: row; border-top-right-radius:0px">
          <div style="align-self: stretch; padding: 2px 10px; background: ${markerColorText.color}; border-top-left-radius: 8px; border-bottom-left-radius: 8px; border: 2px ${'#ffffff'} solid; flex-direction: column; justify-content: center; align-items: center; display: inline-flex;">
            <div  style="width: 16px; height: 16px; position: relative;">
              ${type === '공매' ? PauctionDetailImg('#ffffff') : AuctionDetailImg('#ffffff')}
            </div>
            <div style="text-align: center; color: ${'#ffffff'}; font-size: 12px; font-family: Spoqa Han Sans Neo; font-weight: 700; line-height: 17.40px; word-wrap: break-word;">${type}</div>
          </div>
          <div style="padding: 5px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 1px; display: inline-flex;">
            <div style="width: 100%; height: 100%; padding-right: 10px; border-radius: 9999px; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
              <div style="color: ${markerColorText.color}; font-size: 13px; font-family: Spoqa Han Sans Neo; font-weight: 700; line-height: 21.75px; word-wrap: break-word">감정가 ${transNum(data.appraise_prc)}</div>
              <div style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
              <div style="color: ${markerColorText.color}; font-size: 13px; font-family: Spoqa Han Sans Neo; font-weight: 700; line-height: 21.75px; word-wrap: break-word">최저가 ${transNum(data.price)}</div>
              <div style="color: #616161; font-size: 12px; font-family: Spoqa Han Sans Neo; font-weight: 500; line-height: 17.40px; word-wrap: break-word">${data.category === 'I' ? data.landCategory : data.itemCategory}</div>
              </div>
              <div style="color: #616161; font-size: 12px; font-family: Spoqa Han Sans Neo; font-weight: 500; line-height: 17.40px; word-wrap: break-word">매각기일 ${data.date}</div>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: center; align-items: flex-start; position:absolute; left:45.5%; bottom:-14px ; z-index: 1;">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" fill="none">
            <path d="M4 1.5H2.91289L3.62037 2.3254L8.86111 8.4396C9.45976 9.13801 10.5402 9.13801 11.1389 8.4396L16.3796 2.3254L17.0871 1.5H16H4Z" fill="${markerColorText.color}" stroke="${markerColorText.color}" />
          </svg>
        </div>
        <div style="position: absolute; top: 89px; width: 8px; height: 8px; background: ${markerColorText.color}; box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08); border-radius: 9999px; border: 1px white solid;"></div>
      </div>
    </div>
  `;
};

const RendingRealDealData = (type: string, data: any, markerColorText: any) => {
  realDealButtonYN(markerColorText.text);
  return `
  <div style="border-radius: 8px;  align-self: stretch; height: 100%; box-shadow: 4px 8px 4px rgba(0, 0, 0, 0.08); flex-direction: column; justify-content: flex-start; align-items: center; display: flex; position: relative;">
        <div style="background: ${markerColorText.color}; border-radius: 8px; justify-content: flex-start; align-items: center; display: inline-flex; flex-direction: row; border-top-right-radius:0px">
          <div style="align-self: stretch; padding: 2px 10px; background: white; border-top-left-radius: 8px; border-bottom-left-radius: 8px; border: 1px ${markerColorText.color} solid; flex-direction: column; justify-content: center; align-items: center; display: inline-flex;">
            <div  style="width: 16px; height: 16px; position: relative;">
              ${type === '공매' ? PauctionDetailImg(markerColorText.color) : AuctionDetailImg(markerColorText.color)}
            </div>
            <div style="text-align: center; color: ${markerColorText.color}; font-size: 12px; font-family: Spoqa Han Sans Neo; font-weight: 700; line-height: 17.40px; word-wrap: break-word;">${type === '기타' ? data.itemCategory : type}</div>
          </div>
          <div style="padding: 5px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 1px; display: inline-flex;">
            <div style="padding: 0 6px; background: white; border-radius: 9999px; justify-content: center; align-items: center; gap: 10px; display: inline-flex;">
              <div style="color: ${markerColorText.color}; font-size: 12px; font-family: Spoqa Han Sans Neo; font-weight: 700; line-height: 17.40px; word-wrap: break-word;">${markerColorText.text === '기타' ? data.itemCategory : markerColorText.text}</div>
            </div>
              <div style="padding-right: 10px; border-radius: 9999px; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex;">
                <div style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex;">
                  <div style="color: white; font-size: 13px; font-family: Spoqa Han Sans Neo; font-weight: 700; line-height: 21.75px; word-wrap: break-word;">${transNum(data.price)}</div>
                  <div style="color: rgba(255, 255, 255, 0.78); font-size: 11px; font-family: Spoqa Han Sans Neo; font-weight: 500; line-height: 17.40px; word-wrap: break-word;">${data.area}</div>
                </div>
                <div style="color: rgba(255, 255, 255, 0.78); font-size: 11px; font-family: Spoqa Han Sans Neo; font-weight: 500; line-height: 17.40px; word-wrap: break-word;">매각기일 ${data.date}</div>              
                <div style="width: 100%; background: white; border-radius: 6px; justify-content: flex-start; align-items: center; display: inline-flex; flex-direction:row;  border: 1px #e1e2e4 solid">
                  ${
                    realDealButtonYN(markerColorText.text)
                      ? `<div id= "realDealOnButton-${data.iidx}" style = "padding-left: 8px; padding-right: 8px; padding-top: 2px; padding-bottom: 2px; justify-content: center; align-items: center; gap: 4px; display: flex; flex-direction:row; " >
                    <div style="color: #616161; font-size: 13px; font-family: Spoqa Han Sans Neo; font-weight: 500; line-height: 18.85px; word-wrap: break-word">실거래가</div>
                      <div data-svg-wrapper style="position: relative">
                        <svg width="6" height="15" viewBox="0 0 6 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.775345 11.4122C0.541031 11.1843 0.541031 10.815 0.775345 10.5872L3.95108 7.49967L0.775345 4.41215C0.54103 4.18435 0.54103 3.815 0.775345 3.58719C1.00966 3.35939 1.38956 3.35939 1.62387 3.58719L5.22387 7.08719C5.45819 7.315 5.45819 7.68435 5.22387 7.91215L1.62387 11.4122C1.38956 11.64 1.00966 11.64 0.775345 11.4122Z" fill="#37383C" fill-opacity="0.61"/>
                        </svg>
                      </div>
                  </div>`
                      : ''
                  }
                  <div style="width: 1px; align-self: stretch; background: #E1E2E4"></div>
                  <div  id="detailOnButton-${data.iidx}"  style="pointer-events: auto;  z-index:10000; width:100% ; padding-left: 8px; padding-right: 8px; padding-top: 2px; padding-bottom: 2px; justify-content: center; align-items: center; gap: 4px; display: flex; flex-direction:row;">
                  <div style="color: #616161; font-size: 13px; font-family: Spoqa Han Sans Neo; font-weight: 500; line-height: 18.85px; word-wrap: break-word">상세</div>
                  <div data-svg-wrapper style="position: relative">
                        <svg width="6" height="15" viewBox="0 0 6 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.775345 11.4122C0.541031 11.1843 0.541031 10.815 0.775345 10.5872L3.95108 7.49967L0.775345 4.41215C0.54103 4.18435 0.54103 3.815 0.775345 3.58719C1.00966 3.35939 1.38956 3.35939 1.62387 3.58719L5.22387 7.08719C5.45819 7.315 5.45819 7.68435 5.22387 7.91215L1.62387 11.4122C1.38956 11.64 1.00966 11.64 0.775345 11.4122Z" fill="#37383C" fill-opacity="0.61"/>
                        </svg>
                      </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div style="display: flex; justify-content: center; align-items: flex-start; position:absolute; left:46.1%; bottom:-7%; z-index: 1;">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" fill="none">
            <path d="M4 1.5H2.91289L3.62037 2.3254L8.86111 8.4396C9.45976 9.13801 10.5402 9.13801 11.1389 8.4396L16.3796 2.3254L17.0871 1.5H16H4Z" fill="${markerColorText.color}" stroke="${markerColorText.color}" />
          </svg>
        </div>
        <div style="position: absolute;  top: 104%; left:50%; width: 8px; height: 8px; background: ${markerColorText.color}; box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08); border-radius: 9999px; border: 1px white solid;"></div>
      </div>
    </div>
  `;
};

const realDealButtonYN = (text: string): boolean => {
  return ['아파트', '오피스텔', '다세대(빌라)/연립'].includes(text);
};

// const itemSaleType = (type: string): string => {
//   switch (type.trim()) {

//   }
// }

const RealDealDetailImg = (color: string) => {
  return `
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="House-Chimney--Streamline-Ultimate" clip-path="url(#clip0_5259_22874)">
<path id="Subtract" fill-rule="evenodd" clip-rule="evenodd" d="M14.2131 5.93996L16.3064 8.02663C16.3989 8.12038 16.4616 8.23942 16.4865 8.36875C16.5114 8.49808 16.4975 8.63189 16.4464 8.75329C16.3964 8.87504 16.3115 8.97926 16.2023 9.05281C16.0932 9.12637 15.9647 9.16597 15.8331 9.16663H14.9998C14.9556 9.16663 14.9132 9.18419 14.8819 9.21544C14.8507 9.2467 14.8331 9.28909 14.8331 9.33329V15.8333C14.8331 16.0101 14.7629 16.1797 14.6378 16.3047C14.5128 16.4297 14.3432 16.5 14.1664 16.5H2.8331C2.65629 16.5 2.48672 16.4297 2.3617 16.3047C2.23667 16.1797 2.16643 16.0101 2.16643 15.8333V9.33329C2.16643 9.28909 2.14887 9.2467 2.11762 9.21544C2.08636 9.18419 2.04397 9.16663 1.99977 9.16663H1.16643C1.03482 9.16597 0.90634 9.12637 0.797193 9.05281C0.688046 8.97926 0.603114 8.87504 0.553101 8.75329C0.502048 8.63189 0.488099 8.49808 0.513015 8.36875C0.537932 8.23942 0.600596 8.12038 0.693101 8.02663L8.02643 0.693293C8.08841 0.630807 8.16214 0.581211 8.24338 0.547365C8.32462 0.513519 8.41176 0.496094 8.49977 0.496094C8.58778 0.496094 8.67491 0.513519 8.75615 0.547365C8.83739 0.581211 8.91113 0.630807 8.9731 0.693293L10.5464 2.30663C10.5743 2.32444 10.6067 2.3339 10.6398 2.3339C10.6728 2.3339 10.7052 2.32444 10.7331 2.30663C10.7629 2.29361 10.7883 2.27216 10.806 2.24492C10.8238 2.21767 10.8332 2.18582 10.8331 2.15329V1.83329C10.8331 1.65648 10.9033 1.48691 11.0284 1.36189C11.1534 1.23686 11.323 1.16663 11.4998 1.16663H13.4998C13.6766 1.16663 13.8461 1.23686 13.9712 1.36189C14.0962 1.48691 14.1664 1.65648 14.1664 1.83329V5.83329C14.1707 5.8728 14.187 5.91004 14.2131 5.93996ZM6.27314 11.6931L8.09714 6.77694C8.15886 6.61064 8.32 6.50089 8.5 6.50089C8.68 6.50089 8.84114 6.6112 8.90286 6.7775L10.7269 11.6937L12.0863 6.80997C12.1486 6.58656 12.3806 6.45498 12.6126 6.51545C12.8406 6.57648 12.9754 6.80773 12.9131 7.03115L12.2817 9.30054H13.0714C13.308 9.30054 13.5 9.48867 13.5 9.72048C13.5 9.95229 13.308 10.1404 13.0714 10.1404H12.048L11.1989 13.1904C11.1497 13.3673 10.9897 13.4922 10.8034 13.4994H10.7857C10.6063 13.4994 10.4446 13.3897 10.3829 13.2228L8.5 8.14876L6.61714 13.2228C6.55371 13.3942 6.4 13.5129 6.19657 13.4989C6.01029 13.4916 5.85029 13.3662 5.80114 13.1898L4.952 10.1399H3.92857C3.692 10.1399 3.5 9.95173 3.5 9.71992C3.5 9.48811 3.692 9.29998 3.92857 9.29998H4.71829L4.08686 7.03059C4.024 6.80661 4.15943 6.57592 4.38743 6.51489C4.62 6.45386 4.852 6.586 4.91371 6.80941L6.27314 11.6931Z"
fill="${color}"/>
</g>
<defs>
<clipPath id="clip0_5259_22874">
<rect width="16" height="16" fill="white" transform="translate(0.5 0.5)"/>
</clipPath>
</defs>
</svg>
  `;
};

const AuctionDetailImg = (color: string) => {
  return `
<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame" clip-path="url(#clip0_4001_735)">
<path id="Vector" d="M7.40959 11.5393L3.32504 7.45475C2.94951 7.07921 2.33905 7.07921 1.96352 7.45475L0.948638 8.46961C0.57311 8.84515 0.57311 9.45561 0.948638 9.83115L5.0332 13.9157C5.40873 14.2912 6.01919 14.2912 6.39472 13.9157L7.40959 12.9008C7.78513 12.5253 7.78513 11.9148 7.40959 11.5393Z"
fill="${color}"/>
<path id="Vector_2" d="M10.4191 7.71652L7.1453 4.44269C6.9219 4.2193 6.55792 4.2193 6.33261 4.44269L4.27204 6.50327C4.04864 6.72665 4.04864 7.09063 4.27204 7.31592L7.54584 10.5898C7.76924 10.8131 8.13324 10.8131 8.3585 10.5898L8.5203 10.428C8.5203 10.428 8.52797 10.4261 8.5299 10.428L12.4527 15.0075C13.1094 15.6642 14.1724 15.6642 14.8291 15.0075C15.4858 14.3508 15.4858 13.2878 14.8291 12.6311L10.2554 8.70252C10.2554 8.70252 10.2516 8.69672 10.2554 8.69285L10.4172 8.53112C10.6406 8.30772 10.6406 7.94372 10.4172 7.71845L10.4191 7.71652Z"
fill="${color}"/>
<path id="Vector_3" d="M8.3014 1.1149L7.28653 2.12978C6.911 2.50531 6.911 3.11577 7.28653 3.4913L11.3711 7.57585C11.7466 7.95139 12.3571 7.95139 12.7326 7.57585L13.7475 6.56098C14.123 6.18545 14.123 5.57499 13.7475 5.19946L9.66293 1.1149C9.2874 0.739371 8.67693 0.739371 8.3014 1.1149Z"
fill="${color}"/>
</g>
<defs>
<clipPath id="clip0_4001_735">
<rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>

  `;
};

const PauctionDetailImg = (color: string) => {
  return `
<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame">
<g id="Clip path group">
<mask id="mask0_4001_2649" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="1" width="16" height="15">
<g id="clip0_4160_2851">
<path id="Vector" d="M15.737 1.1665H0.263672V15.8332H15.737V1.1665Z" fill="${color}"/>
</g>
</mask>
<g mask="url(#mask0_4001_2649)">
<g id="Group">
<path id="Vector_2" d="M12.7122 2.38872H3.28885C2.95273 2.38872 2.67773 2.11372 2.67773 1.77762C2.67773 1.4415 2.95273 1.1665 3.28885 1.1665H12.7122C13.0483 1.1665 13.3233 1.4415 13.3233 1.77762C13.3233 2.11372 13.0483 2.38872 12.7122 2.38872Z"
fill="${color}"/>
<path id="Vector_3" d="M0.752559 8.70166H5.87979C6.14867 8.70166 6.36867 8.92166 6.36867 9.19053V9.31279C6.36867 10.9995 4.99979 12.3683 3.31312 12.3683C1.63256 12.3683 0.263672 10.9995 0.263672 9.31279V9.19053C0.263672 8.92166 0.483672 8.70166 0.752559 8.70166Z"
fill="${color}"/>
<path id="Vector_4" d="M3.31917 3.60478L5.08527 8.70144H5.73305L3.60639 2.572C3.52083 2.32756 3.1175 2.32756 3.02583 2.572L0.905273 8.70144H1.55305L3.31917 3.60478Z"
fill="${color}"/>
<path id="Vector_5" d="M10.1151 8.70166H15.2423C15.5113 8.70166 15.7313 8.92166 15.7313 9.19053V9.31279C15.7313 10.9995 14.3623 12.3683 12.6757 12.3683C10.989 12.3683 9.62012 10.9995 9.62012 9.31279V9.19053C9.62012 8.92166 9.84012 8.70166 10.109 8.70166H10.1151Z"
fill="${color}"/>
<path id="Vector_6" d="M12.6817 3.60478L14.4479 8.70144H15.0956L12.9689 2.572C12.8834 2.32756 12.4801 2.32756 12.3884 2.572L10.2617 8.70144H10.9095L12.6756 3.60478H12.6817Z"
fill="${color}"/>
<path id="Vector_7" d="M8.61165 15.8331H7.38945C7.05332 15.8331 6.77832 15.5581 6.77832 15.222L7.38945 2.38867H8.61165L9.22279 15.222C9.22279 15.5581 8.94779 15.8331 8.61165 15.8331Z"
fill="${color}"/>
</g>
</g>
</g>
</g>
</svg>
  `;
};

const RealDealViewIcon = (color: string) => {
  return `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Subscription-Cashflow--Streamline-Core" clip-path="url(#clip0_4018_764)">
<g id="subscription-cashflow">
<path id="Vector" d="M2.28418 15.4265V12.5693H5.14132" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Ellipse 1132" d="M15.3001 6.63281C16.011 10.4133 13.6975 14.1613 9.92032 15.1733C7.02941 15.9479 4.07971 14.906 2.2832 12.7471" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Ellipse 1133" d="M0.699272 9.3668C-0.0116325 5.58629 2.30187 1.83834 6.07905 0.826255C8.96977 0.0516887 11.9193 1.09348 13.7159 3.25203" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_2" d="M13.7156 0.573242V3.43039H10.8584" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<path id="Vector_3" d="M7.59714 4.77694L5.77314 9.69311L4.41371 4.80941C4.352 4.586 4.12 4.45386 3.88743 4.51489C3.65943 4.57592 3.524 4.80661 3.58686 5.03059L4.21829 7.29998H3.42857C3.192 7.29998 3 7.48811 3 7.71992C3 7.95173 3.192 8.13987 3.42857 8.13987H4.452L5.30114 11.1898C5.35029 11.3662 5.51029 11.4916 5.69657 11.4989C5.9 11.5129 6.05371 11.3942 6.11714 11.2228L8 6.14876L9.88286 11.2228C9.94457 11.3897 10.1063 11.4994 10.2857 11.4994C10.2914 11.4994 10.2977 11.4994 10.3034 11.4994C10.4897 11.4922 10.6497 11.3673 10.6989 11.1904L11.548 8.14043H12.5714C12.808 8.14043 13 7.95229 13 7.72048C13 7.48867 12.808 7.30054 12.5714 7.30054H11.7817L12.4131 5.03115C12.4754 4.80773 12.3406 4.57648 12.1126 4.51545C11.8806 4.45498 11.6486 4.58656 11.5863 4.80997L10.2269 9.69367L8.40286 4.7775C8.34114 4.6112 8.18 4.50089 8 4.50089C7.82 4.50089 7.65886 4.61064 7.59714 4.77694Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_4018_764">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
  `;
};

const PlannedDetailIcon = (color: string) => {
  return `
<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Cost-Of-Living-Calendar--Streamline-Ultimate" clip-path="url(#clip0_4001_3472)">
<g id="Group">
<path id="Vector" d="M15.8802 12.7998L12.5469 8.9665C12.3697 8.7759 12.1551 8.62387 11.9165 8.51991C11.6779 8.41596 11.4204 8.3623 11.1602 8.3623C10.8999 8.3623 10.6425 8.41596 10.4039 8.51991C10.1653 8.62387 9.95073 8.7759 9.77353 8.9665L6.4402 12.7998C6.37852 12.8739 6.33893 12.9638 6.32596 13.0593C6.31299 13.1548 6.32717 13.252 6.36687 13.3398C6.40709 13.4265 6.47099 13.5 6.5512 13.5519C6.63141 13.6038 6.72467 13.632 6.8202 13.6332H8.15353V16.4998H14.1535V13.6332H15.4869C15.5824 13.632 15.6757 13.6038 15.7559 13.5519C15.8361 13.5 15.9 13.4265 15.9402 13.3398C15.9817 13.2532 15.9981 13.1567 15.9875 13.0612C15.9769 12.9658 15.9397 12.8752 15.8802 12.7998ZM12.3335 16.4998H10.0002V14.0532C10.0002 13.7438 10.1231 13.447 10.3419 13.2282C10.5607 13.0094 10.8574 12.8865 11.1669 12.8865C11.4763 12.8865 11.773 13.0094 11.9918 13.2282C12.2106 13.447 12.3335 13.7438 12.3335 14.0532V16.4998Z"
fill="${color}"/>
<g id="Group_2">
<g id="Group_3">
<path id="Vector_2" d="M3.13302 4.80667C2.98346 4.80535 2.8369 4.84858 2.712 4.93085C2.5871 5.01312 2.48951 5.1307 2.43167 5.26862C2.37383 5.40654 2.35835 5.55856 2.3872 5.70531C2.41606 5.85206 2.48794 5.98691 2.59369 6.09266C2.69945 6.19842 2.83429 6.2703 2.98104 6.29915C3.12779 6.32801 3.27981 6.31253 3.41773 6.25469C3.55565 6.19684 3.67324 6.09926 3.75551 5.97436C3.83777 5.84945 3.881 5.70289 3.87968 5.55334C3.87794 5.35585 3.79872 5.16694 3.65907 5.02729C3.51942 4.88764 3.33051 4.80841 3.13302 4.80667Z"
fill="${color}"/>
<path id="Vector_3" d="M3.13302 7.40677C2.98346 7.40545 2.8369 7.44868 2.712 7.53095C2.5871 7.61321 2.48951 7.7308 2.43167 7.86872C2.37383 8.00664 2.35835 8.15866 2.3872 8.30541C2.41606 8.45216 2.48794 8.587 2.59369 8.69276C2.69945 8.79851 2.83429 8.8704 2.98104 8.89925C3.12779 8.92811 3.27981 8.91263 3.41773 8.85478C3.55565 8.79694 3.67324 8.69935 3.75551 8.57445C3.83777 8.44955 3.881 8.30299 3.87968 8.15343C3.87794 7.95594 3.79872 7.76704 3.65907 7.62738C3.51942 7.48773 3.33051 7.40851 3.13302 7.40677Z"
fill="${color}"/>
<path id="Vector_4" d="M5.84661 4.80656C5.6599 4.82418 5.48647 4.91081 5.36024 5.04951C5.23402 5.18822 5.16406 5.36901 5.16406 5.55656C5.16406 5.7441 5.23402 5.9249 5.36024 6.0636C5.48647 6.2023 5.6599 6.28893 5.84661 6.30656C5.95104 6.31641 6.05638 6.30435 6.15588 6.27114C6.25539 6.23793 6.34686 6.18431 6.42444 6.11371C6.50202 6.04311 6.564 5.95708 6.60641 5.86114C6.64882 5.7652 6.67073 5.66145 6.67073 5.55656C6.67073 5.45166 6.64882 5.34792 6.60641 5.25197C6.564 5.15603 6.50202 5.07001 6.42444 4.9994C6.34686 4.9288 6.25539 4.87518 6.15588 4.84197C6.05638 4.80876 5.95104 4.7967 5.84661 4.80656Z"
fill="${color}"/>
<path id="Vector_5" d="M5.84661 7.40665C5.6599 7.42428 5.48647 7.51091 5.36024 7.64961C5.23402 7.78831 5.16406 7.96911 5.16406 8.15665C5.16406 8.3442 5.23402 8.52499 5.36024 8.6637C5.48647 8.8024 5.6599 8.88903 5.84661 8.90665C5.95104 8.91651 6.05638 8.90445 6.15588 8.87124C6.25539 8.83803 6.34686 8.78441 6.42444 8.71381C6.50202 8.6432 6.564 8.55718 6.60641 8.46123C6.64882 8.36529 6.67073 8.26155 6.67073 8.15665C6.67073 8.05176 6.64882 7.94801 6.60641 7.85207C6.564 7.75613 6.50202 7.6701 6.42444 7.5995C6.34686 7.5289 6.25539 7.47528 6.15588 7.44207C6.05638 7.40886 5.95104 7.3968 5.84661 7.40665Z"
fill="${color}"/>
<path id="Vector_6" d="M8.5595 6.30656C8.66393 6.31641 8.76927 6.30435 8.86877 6.27114C8.96828 6.23793 9.05975 6.18431 9.13733 6.11371C9.21491 6.04311 9.27689 5.95708 9.3193 5.86114C9.36171 5.7652 9.38362 5.66145 9.38362 5.55656C9.38362 5.45166 9.36171 5.34792 9.3193 5.25197C9.27689 5.15603 9.21491 5.07001 9.13733 4.9994C9.05975 4.9288 8.96828 4.87518 8.86877 4.84197C8.76927 4.80876 8.66393 4.7967 8.5595 4.80656C8.37279 4.82418 8.19936 4.91081 8.07313 5.04951C7.94691 5.18822 7.87695 5.36901 7.87695 5.55656C7.87695 5.7441 7.94691 5.9249 8.07313 6.0636C8.19936 6.2023 8.37279 6.28893 8.5595 6.30656Z"
fill="${color}"/>
<path id="Vector_7" d="M8.5595 7.40665C8.37279 7.42428 8.19936 7.51091 8.07313 7.64961C7.94691 7.78831 7.87695 7.96911 7.87695 8.15665C7.87695 8.3442 7.94691 8.52499 8.07313 8.6637C8.19936 8.8024 8.37279 8.88903 8.5595 8.90665C8.66393 8.91651 8.76927 8.90445 8.86877 8.87124C8.96828 8.83803 9.05975 8.78441 9.13733 8.71381C9.21491 8.6432 9.27689 8.55718 9.3193 8.46123C9.36171 8.36529 9.38362 8.26155 9.38362 8.15665C9.38362 8.05176 9.36171 7.94801 9.3193 7.85207C9.27689 7.75613 9.21491 7.6701 9.13733 7.5995C9.05975 7.5289 8.96828 7.47528 8.86877 7.44207C8.76927 7.40886 8.66393 7.3968 8.5595 7.40665Z"
fill="${color}"/>
</g>
<path id="Vector_8" d="M10.5 0.5H9.16667V1.56667C9.16667 1.69928 9.11399 1.82645 9.02022 1.92022C8.92645 2.01399 8.79928 2.06667 8.66667 2.06667C8.53406 2.06667 8.40688 2.01399 8.31311 1.92022C8.21935 1.82645 8.16667 1.69928 8.16667 1.56667V0.5H3.83333V1.56667C3.83333 1.69928 3.78066 1.82645 3.68689 1.92022C3.59312 2.01399 3.46594 2.06667 3.33333 2.06667C3.20073 2.06667 3.07355 2.01399 2.97978 1.92022C2.88601 1.82645 2.83333 1.69928 2.83333 1.56667V0.5H1.5C1.10218 0.5 0.720644 0.658035 0.43934 0.93934C0.158035 1.22064 0 1.60218 0 2L0 10C0 10.3978 0.158035 10.7794 0.43934 11.0607C0.720644 11.342 1.10218 11.5 1.5 11.5H5.5C5.63261 11.5 5.75979 11.4473 5.85355 11.3536C5.94732 11.2598 6 11.1326 6 11C6 10.8674 5.94732 10.7402 5.85355 10.6464C5.75979 10.5527 5.63261 10.5 5.5 10.5H1.5C1.36793 10.4983 1.24175 10.445 1.14836 10.3516C1.05496 10.2582 1.00173 10.1321 1 10V3.22H11V5C11 5.13261 11.0527 5.25979 11.1464 5.35355C11.2402 5.44732 11.3674 5.5 11.5 5.5C11.6326 5.5 11.7598 5.44732 11.8536 5.35355C11.9473 5.25979 12 5.13261 12 5V2C12 1.60218 11.842 1.22064 11.5607 0.93934C11.2794 0.658035 10.8978 0.5 10.5 0.5Z"
fill="${color}"/>
</g>
</g>
</g>
<defs>
<clipPath id="clip0_4001_3472">
<rect width="16" height="16" fill="${color}" transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>
  `;
};
